export const TIMELINE_FALLBACK_EVENTS = [
  {
    id: 1,
    action: 'period-info',
    team: {}
  },
  {
    id: 2,
    action: 'common',
    team: {}
  },
  {
    id: 3,
    action: 'common',
    team: {}
  },
  {
    id: 4,
    action: 'common',
    team: {}
  },
  {
    id: 5,
    action: 'common',
    team: {}
  },
  {
    id: 6,
    action: 'period-info',
    team: {}
  },
  {
    id: 7,
    action: 'common',
    team: {}
  },
  {
    id: 8,
    action: 'common',
    team: {}
  }
]
